import api from '../api';

export const GetEquipmentTest = async (nrPLataforma: number) => {
    const token = localStorage.getItem('token');

    try {
        const { data } = await api.get<{ Data: number | null }>(`/v1/Sistemas/RequestDeviceTest?nrPLataforma=${nrPLataforma}`, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });

        return data.Data;
    } catch (error) {
        console.error('error', error);
        return null;
    }
}
